export const baseUrl = "https://jsonplaceholder.typicode.com";

export const BASE_URL_STAGING = "https://listcrime-backend.appmaister.com/";
//export const BASE_URL_STAGING = "http://localhost:3001/";

export const BASE_URL_STAGINGHTTP = "https://listcrime-backend.appmaister.com/api";
//export const BASE_URL_STAGINGHTTP = "http://localhost:3001/api";

export const CHAT_PORTURL = "https://listcrime-backend.appmaister.com";
//export const CHAT_PORTURL = "http://localhost:3001";

export const INITIAL_TOKEN = "f8b4814c-251d-4def-bdd0-b62d71569c6d";
